<template>
  <div class="simple-container">
    <div class="simple">
      <slot />
      <p class="mt-5 mb-3 text-muted">Oddular © 2016-2020</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'simple',
};
</script>

<style>
.simple-container {
  height: 100%;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
}

.simple {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
  text-align: center;
}
.simple .checkbox {
  font-weight: 400;
}
.simple .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.simple .form-control:focus {
  z-index: 2;
}
.simple input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.simple input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
